<template>
  <div class="dashboard-container">
    <!-- 搜索 S -->
    <div class="top-search">
      <div class="search">
        <div class="content">
          <el-date-picker
            v-model="timeWrap"
            type="datetimerange"
            align="right"
            format="yyyy-MM-dd hh:mm:ss"
            value-format="yyyy-MM-ddThh:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '00:00:00']"
          ></el-date-picker>
          <div class="right-btns">
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              class="search-btn"
              @click="search"
            >搜索</el-button>
            <el-button
              round
              class="reset-btn"
              icon="el-icon-refresh"
              style="margin-left:20px;"
              @click="reset"
            >重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索 E -->
    <!-- <div class="table-title">当前App：{{curAppName}}</div> -->

    <div class="tab-container">
      <!-- 选项 S -->
      <div class="tab-container-top">
        <div style="margin-bottom:-1px; display:flex;">
          <div
            class="tab-title"
            @click="changeTab(1)"
            :class="activeTab === 1 ? 'active' : '' "
          >数据列表</div>
          <div class="tab-title" @click="changeTab(2)" :class="activeTab === 2 ? 'active' : '' ">折线图</div>
        </div>
      </div>
      <!-- 选项 E -->

      <div class="tab-container-bottom">
        <!-- 折线图 S -->
        <div class="chart-container" v-if="activeTab === 2">
          <keep-alive>
            <echart :Xdata="Xdata" :Sdata="Sdata" :Ldata="Ldata"></echart>
          </keep-alive>
          <echart-out :Xdata="Xdata1" :Sdata="Sdata1" :Ldata="Ldata1"></echart-out>
        </div>
        <!-- 折线图 E -->

        <!-- 表格 S -->
        <div class="table-container" v-if="activeTab === 1">
          <div class="table-tip">数据表</div>

          <el-table
            v-loading="loading"
            :data="tableData"
            empty-text="暂无数据"
            style="width: 100%"
            height="550"
            :row-style="{background: '#FCFDFF'}"
            :header-cell-style="{background:'#2d3a5b',color:'#ffffff'}"
          >
            <el-table-column
              align="center"
              v-for="(item, index) in headerList"
              :key="index"
              :label="item.label"
            >
              <el-table-column
                align="center"
                v-for="(it, ind) in item.child"
                :key="ind"
                :label="it.label"
                v-show="it.label !== item.label"
              >
                <template slot-scope="scope">
                  <span>{{scope.row[it.prop] ? scope.row[it.prop] : '—'}}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <pagination
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.limit"
            @pagination="getList()"
          />
          <div style="width:100px;height:20px;" />
        </div>
        <!-- 表格 E -->
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons");
import { mapGetters } from "vuex";
import { reportAppList } from "@/api/inout.js";
import Pagination from "@/components/Pagination";
import Echart from "./chart";
import EchartOut from "./chartOut";

export default {
  name: "Dashboard",
  computed: {
    ...mapGetters(["name"]),
  },
  components: {
    Pagination,
    Echart,
    EchartOut,
  },
  filters: {
    priceFilter: function name(num) {
      const price = num / 10;
      return price.toString().indexOf(".") !== -1
        ? price.toLocaleString()
        : price.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
  },
  data() {
    return {
      curAppName: "",
      Sdata: [],
      Xdata: [],
      Ldata: [],
      Sdata1: [],
      Xdata1: [],
      Ldata1: [],
      activeTab: 1,
      chart: null,
      outChart: null,
      loading: false,
      timeWrap: [],
      pagination: {
        limit: 10,
        page: 1,
        total: 20,
      },
      tableData1: [],
      headerList: [],
      tableData: [],
      dt_st: "",
      dt_ed: "",
    };
  },

  created() {
    const that = this;
    const start = new Date();
    const end = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
    that.timeWrap[0] = that.formatData(start);
    that.timeWrap[1] = that.formatData(end);

    this.curAppName = this.$route.query.name;

    this.getList();
  },

  mounted() {
    // this.$nextTick(() => {
    //   this.initInEchart();
    //   this.initOutEchart();
    // });
  },

  beforeDestroy() {
    // 清除实例
    if (this.chart) {
      this.chart.clear();
      this.chart.dispose();
      this.chart = null;
    }
    if (this.outChart) {
      this.outChart.clear();
      this.outChart.dispose();
      this.outChart = null;
    }
  },

  methods: {
    changeTab(val) {
      this.activeTab = val;
    },
    // 绘制收入chart
    initInEchart() {
      this.chart = echarts.init(document.getElementById("income-chart"));
      this.chart.setOption({
        title: {
          text: "收入趋势图",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [],
        },
        grid: [
          {
            left: "3%",
            right: "3%",
            bottom: "3%",
            containLabel: true,
          },
        ],
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
      });

      this.chart.showLoading();
      let params = {
        app: this.$route.query.id,
        dt_st: this.timeWrap[0],
        dt_ed: this.timeWrap[1],
      };
      reportAppList(params).then((res) => {
        this.chart.hideLoading();
        let ex = [];
        let inTypeLabel = [];
        let inLable = [];
        // 遍历 收入 类别
        res.headers[1].child.forEach((item) => {
          inLable.push(item.label);
          inTypeLabel.push({
            name: item.label,
            type: "line",
            data: [],
            prop: item.prop,
          });
        });
        // 遍历 x轴 日期
        res.rows.forEach((item) => {
          ex.push(item.date);
          inTypeLabel.forEach((type) => {
            if (type.prop in item) {
              type.data.push(item[type.prop]);
            } else {
              type.data.push(0);
            }
          });
        });

        this.chart.setOption({
          legend: {
            data: inLable,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: ex,
          },
          series: inTypeLabel,
        });
      });
    },

    // 绘制支出chart
    initOutEchart() {
      this.outChart = echarts.init(document.getElementById("outcome-chart"));
      this.outChart.setOption({
        title: {
          text: "支出趋势图",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
      });

      this.outChart.showLoading();
      let params = {
        app: this.$route.query.id,
        dt_st: this.timeWrap[0],
        dt_ed: this.timeWrap[1],
      };
      reportAppList(params).then((res) => {
        this.outChart.hideLoading();
        let ex = [];
        let inTypeLabel = [];
        let inLable = [];
        // 遍历 支出 类别
        res.headers[2].child.forEach((item) => {
          inLable.push(item.label);
          inTypeLabel.push({
            name: item.label,
            type: "line",
            data: [],
            prop: item.prop,
          });
        });
        // 遍历 x轴 日期
        res.rows.forEach((item) => {
          ex.push(item.date);
          inTypeLabel.forEach((type) => {
            if (type.prop in item) {
              type.data.push(item[type.prop]);
            } else {
              type.data.push(0);
            }
          });
        });

        this.outChart.setOption({
          legend: {
            data: inLable,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: ex,
          },
          series: inTypeLabel,
        });
      });
    },

    // 初始化日期
    formatData(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday + "T" + "00:00:00";
    },

    getList() {
      this.loading = true;
      let params = {
        app: this.$route.query.id,
        dt_st: this.timeWrap[0],
        dt_ed: this.timeWrap[1],
      };
      reportAppList(params).then((res) => {
        this.headerList = res.headers;
        this.tableData = res.rows;
        this.loading = false;
        this.pagination.total = res.rows.length;

        let ex = [];
        let inTypeLabel = [];
        let inLable = [];
        // 遍历 收入 类别
        res.headers[1].child.forEach((item) => {
          inLable.push(item.label);
          inTypeLabel.push({
            name: item.label,
            type: "line",
            data: [],
            prop: item.prop,
          });
        });
        // 遍历 x轴 日期
        res.rows.forEach((item) => {
          ex.push(item.date);
          inTypeLabel.forEach((type) => {
            if (type.prop in item) {
              type.data.push(item[type.prop]);
            } else {
              type.data.push(0);
            }
          });
        });
        this.Sdata = inTypeLabel;
        this.Xdata = ex;
        this.Ldata = inLable;

        let ex1 = [];
        let inTypeLabel1 = [];
        let inLable1 = [];
        // 遍历 支出 类别
        res.headers[2].child.forEach((item) => {
          inLable1.push(item.label);
          inTypeLabel1.push({
            name: item.label,
            type: "line",
            data: [],
            prop: item.prop,
          });
        });
        // 遍历 x轴 日期
        res.rows.forEach((item) => {
          ex1.push(item.date);
          inTypeLabel1.forEach((type) => {
            if (type.prop in item) {
              type.data.push(item[type.prop]);
            } else {
              type.data.push(0);
            }
          });
        });

        this.Sdata1 = inTypeLabel1;
        this.Xdata1 = ex1;
        this.Ldata1 = inLable1;
      });
    },

    search() {
      if (this.timeWrap === null) {
        this.$message({
          message: "请选择日期",
          type: "warning",
        });
        return false;
      } else {
        let params = {
          app: this.$route.query.id,
          dt_st: this.timeWrap[0],
          dt_ed: this.timeWrap[1],
        };
        reportAppList(params).then((res) => {
          console.log(res);
          this.headerList = res.headers;
          this.tableData = res.rows;

          // 绘制图表
          this.initOutEchart();
          this.initInEchart();
        });
      }
    },
    reset() {},
  },
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.top-search {
  display: flex;
  padding: 20px 20px 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #f0f3f7;
}
.table-container {
  min-height: 400px;
  margin-top: 20px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eff2f7;
}
.search {
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  .content {
    @include flex(center, space-between);
    border-radius: 4px;
    height: 76px;
    width: 100%;
    margin: 0 auto;
  }
}
.pageContain {
  @include flex(center, flex-end);
  margin-top: 20px;
}
.search-btn {
  background-color: #2d3a5b;
  border: #2d3a5b;
}
.reset-btn {
  background-color: #ffffff;
  color: #2d3a5b;
  border: 1px solid #2d3a5b;
}

.tab-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border: 1px solid #2d3a5b;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  &-top {
    width: 100%;
    color: #fff;
    background-color: rgba(45, 58, 91, 0.9);
    border-bottom: 1px solid #e4e7ed;
  }
  &-bottom {
    width: 100%;
  }
}
.active {
  color: #2d3a5b;
  background-color: #fff;
}
.tab-title {
  @include flex(center, center);
  width: 120px;
  height: 50px;
  cursor: pointer;
}
.table-tip {
  margin: 30px;
  font-size: 18px;
  font-weight: 400;
}
.table-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin-top: 20px;

  color: #2d3a5b;
  background-color: #ffffff;
}
</style>
